import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'

/**
 * Displays the full name of the user's person.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
export const ListItemCellUserName = (classes, props = {}) => {
  const { person: { value: { firstName, lastName } = {} } = {} } = props
  const fullName = firstName && lastName
    ? `${firstName} ${lastName}`
    : '-'

  return (
    <Typography
      color={'black'}
      variant={'body2'}
      className={classes.row}
      sx={{ fontWeight: 700 }}
    >
      {fullName}
    </Typography>
  )
}

export default CellHOC(ListItemCellUserName)
